import { store } from '../../store'
import { plainToClass } from 'class-transformer'
import { ListQuizTopicsDTO } from '../../dto/quizes'
import { validate } from 'class-validator'

export const listQuizTopics = async () => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/quizes/topics`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'GET'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_QUIZ_TOPICS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_QUIZ_TOPICS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_QUIZ_TOPICS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListQuizTopicsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_QUIZ_TOPICS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_QUIZ_TOPICS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_QUIZ_TOPICS_OK', quizTopics: body.quizTopics } )

}